export default __webpack_public_path__ + "e84ba173158dfea3cd6c5fd5a0910743.svg";